import { render, staticRenderFns } from "./payment-button.vue?vue&type=template&id=1d1112a6&scoped=true"
import script from "./payment-button.vue?vue&type=script&lang=js"
export * from "./payment-button.vue?vue&type=script&lang=js"
import style0 from "./payment-button.vue?vue&type=style&index=0&id=1d1112a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1112a6",
  null
  
)

export default component.exports